import React, { useState, useEffect } from "react";
import CertificateIcon from "../../assets/assets/certificate.svg";
import "rodal/lib/rodal.css";
import Storage from "../../utils/storage";
import "react-circular-progressbar/dist/styles.css";
import { getApplicationHash } from "../../redux/Actions/PosActions";
import { getCertificationAmountByAppId } from "../../redux/Actions/GetDocsActions";

import Spinner from "react-spinner-material";
import { useHistory } from "react-router-dom";
import TermsModal from "../Modals/TermsModal";

import CertificateModal from "../Modals/CertificateModal";
import RunTestModal from "../Modals/RunTestModal";
import Certificate from "../../components/Certification/Certificate";
import DeviceStatus from "../../components/Certification/DeviceStatus";
import ApplicationStatus from "../../components/Certification/ApplicationStatus";
import { PropTypes } from "prop-types";
import ReapplySection from "../../components/Certification/ReapplySection";
import { connect } from "react-redux";
import EditableCertificationName from "../../components/Certification/EditableCertificationName";



export const POSSingle = ({
  trails,
  isGetting,
  trailLength,
  submitAgreement,
  isSubmitting,
  submitSuccess,
  getUserTrail,
  applicationHashValue,
  getApplicationHash,
  merchantClass,
  getCertificationAmountByAppId,


}) => {
      const [reload, setReload] = useState(false);
  const history = useHistory();
  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let userType = user && user.type;

  const [state, setState] = useState({
    checkedOptionState: false,
    showModal: false,

    hideError: true,
    showCertModal: false,
    openTestModal: false,
    visible: false,
    copied: false,
    index: "",
    testModalIndex: 0,
    certModalIndex: "",
  });

  const openModal = () => {
    setState({
      ...state,
      showModal: true,
    });
  };



  const hideModal = () => {
    setState({
      ...state,
      showModal: false,
    });
  };

  const viewCert = (index) => {
    setState({
      ...state,
      showCertModal: true,
      certModalIndex: index,
    });
  };

  const hideCert = () => {
    setState({
      ...state,
      showCertModal: false,
    });
  };

  const openTestModal = (index, tid) => {
    setState({
      ...state,
      testModalIndex: index,
      showTestModal: true,
    });
    getApplicationHash(tid)
  };

  // updated: ensure merchant_class is fetched when opening the TID modal
  const openTestModalWithApp = (index, tid, appId) => {
    setState({
      ...state,
      testModalIndex: index,
      showTestModal: true,
    });
    getApplicationHash(tid);
    if (appId) {
      getCertificationAmountByAppId(appId);
    }
  };

  const hideTestModal = () => {
    setState({
      ...state,
      showTestModal: false,
    });
  };

  const hideBar = (index) => {
    setState({
      ...state,
      testModalIndex: index,
      hideError: false,
    });
  };



  const myFunction = (data, index) => {
    setState({
      copied: true,
      hideError: true,
      showTestModal: true,
      index: data,
      testModalIndex: index,
    });
    var textField = document.createElement("textarea");
    textField.innerText = data;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
  };

  // source merchantClass for this flow (preferred: redux prop, fallback: localStorage)
  const merchantClassSource = merchantClass || Storage.get("merchant_class");

  const runTest = (appId, companyId, tid, portNo, newtype, merchantClassParam) => {

    let newType = "";
    if (newtype === "pos_device_certification") {
      newType = "device";
    } else {
      newType = "application";
    }
    history.push({
      pathname: "/test",
      state: {
        id: appId,
        companyId: companyId,
        tid: tid,
        portNo: portNo,
        type: newType,
        merchantClass: merchantClassParam || merchantClassSource,
      },
    });
  };

  useEffect(() => {
    const handlePopState = () => {
      setReload((prev) => !prev); // Toggle state to force re-render
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);


  return (
    <div>
      {userType !== "staff" && (
        <ReapplySection
          href={"/apply"}
          type={"POS Certification"}
          application={trails}
          title={"Easy Application for your certificates"}
        />
      )}

      {isGetting ? (
        <div className="singlepos">
          <div className="center-spinner">
            <Spinner
              size={120}
              color={"#047558"}
              spinnerwidth={5}
              visible={true}
            />
          </div>
        </div>
      ) : trailLength > 0 ? (
        <div className="singlepos">
          <div className="top">
            <div style={{ display: "flex" }}>
              <div className="singlepos-image">
                <img src={CertificateIcon} alt="cert" />
              </div>
              <div className="singlepos-text">
                <h2>POS Certification</h2>
                <p>
                  Get access to all POS (Device or Application) certification
                </p>
              </div>
            </div>

            <div className="top-right">
              <a href="/applications">VIEW ALL APPLICATIONS</a>
            </div>
          </div>

          {trails &&
            trails.map((trail, index) => (
        
              <div key={index} className="main-main-div">
                <br />
                
                {state.hideError &&
                  trail.trail &&
                  trail.trail.admin &&
                  trail.trail.admin.applicationApprovalStatus === true &&
                  trail.trail &&
                  trail.trail.admin &&
                  trail.trail.admin.testApprovalStatus === false &&
                  trail.application_type ===
                  "pos_application_certification" && (
                    <div className="singlenot">
                      <p>
                        Your POS{" "}
                        {trail.application_type === "pos_device_certification"
                          ? "Device"
                          : "Application"}{" "}
                        certification documents and payment has been reviewed
                        and <br /> a TID and Port Number has been assigned for
                        this application
                      </p>
                      <div className="singlenot-btn">




                        <button
                          data-testid="getTestModal"
                          // onClick={() => openTestModal(index, trail.terminal_id)}
                          onClick={() => openTestModalWithApp(index, trail.terminal_id, trail && trail.id)}
                        >
                          VIEW TID AND PORT NUMBER
                        </button>
                        <div
                          data-testid="cancel-icon"
                          className="cancel-icon"
                          onClick={() => hideBar(trail.id)}
                        >
                          X
                        </div>
                      </div>
                    </div>
                  )}
                {/* {trail.application_type === "pos_device_certification" &&
                  trail &&
                  trail.trail &&
                  Object.keys(trail.trail).length !== 0 && (
                    <DeviceStatus trail={trail} userType={userType} />
                  )}
                {trail.application_type === "pos_application_certification" &&
                  trail &&
                  trail.trail &&
                  Object.keys(trail.trail).length !== 0 && (
                    <ApplicationStatus trail={trail} userType={userType} />
                  )} */}

                {trail && trail.trail && Object.keys(trail.trail).length !== 0 && (
                  <>
                    {trail.application_type === "pos_device_certification" && (
                      <DeviceStatus trail={trail} userType={userType} EditableCertificationName={EditableCertificationName} />
                    )}
                    {trail.application_type === "pos_application_certification" && (
                      <ApplicationStatus trail={trail} userType={userType} EditableCertificationName={EditableCertificationName} />
                    )}
                  </>
                )}

                <Certificate
                  trail={trail}
                  viewCert={() => viewCert(index)}
                  userType={userType}
                  isSubmitting={isSubmitting}
                  submitAgreement={submitAgreement}
                  openModal={openModal}
                  submitSuccess={submitSuccess}
                  getUserTrail={getUserTrail}
                />

                {index === state.certModalIndex && (
                  <CertificateModal
                    showCertModal={state.showCertModal}
                    hideCert={hideCert}
                    certificateUrl={trail && trail.certificate_url}
                  />
                )}

                {index === state.testModalIndex && (
                  <RunTestModal
                    showTestModal={state.showTestModal}
                    hideTestModal={hideTestModal}
                    tid={trail && trail.terminal_id}
                    myFunction={myFunction}
                    index={state.index}
                    testIndex={index}
                    portNo={trail && trail.port_number}
                    type={trail && trail.application_type}
                    copied={state.copied}
                    disabled={
                      trail.trail &&
                      trail.trail.admin &&
                      trail.trail.admin.certificateAssigned === true
                    }
                    userType={userType}
                    runTest={runTest}
                    appId={trail.id}
                    companyId={trail.company && trail.company.company_id}
                    merchantClass={merchantClass || Storage.get("merchant_class")}


                  />
                )}



              </div>
            ))}
        </div>
      ) : (
        <div className="singlepos">
          <div className="top">
            <div style={{ display: "flex" }}>
              <div className="singlepos-image">
                <img src={CertificateIcon} alt="cert" />
              </div>
              <div className="singlepos-text">
                <h2>POS Certification</h2>
                <p>
                  Get access to all POS (Device or Application) certification
                </p>
              </div>
            </div>

            <div className="top-right">
              <a href="/applications">VIEW ALL APPLICATIONS</a>
            </div>
          </div>

          <div>
            <h3 className="no-cert-progress">No Certification in progress</h3>
          </div>
        </div>
      )}

      <TermsModal showModal={state.showModal} hideModal={hideModal} />
    </div>
  );
};



const mapDispatchToProps = (dispatch) => ({
  getApplicationHash: (tid) => dispatch(getApplicationHash(tid)),
  getCertificationAmountByAppId: (id) => dispatch(getCertificationAmountByAppId(id)),

});

const mapStateToProps = (state) => {
  return {
    applicationHashValue: state.pos.applicationHashDetails,
    merchantClass: state.docs && state.docs.merchantClass,


  };
};

POSSingle.propTypes = {
  trails: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  isGetting: PropTypes.bool,
  trailLength: PropTypes.number,
  type: PropTypes.string,
  trailAdmin: PropTypes.object,
  submitAgreement: PropTypes.func,
  isSubmitting: PropTypes.bool,
  submitSuccess: PropTypes.bool,
  getUserTrail: PropTypes.func,
  appHashValue: PropTypes.string,
  centerLongitude: PropTypes.number,
  centerLatitude: PropTypes.number,
  geolocationViolated: PropTypes.bool,
  hashViolated: PropTypes.bool,
  merchantRadius: PropTypes.number,
  getApplicationHash: PropTypes.func.isRequired,
  getCertificationAmountByAppId: PropTypes.func.isRequired,
  applicationHashValue: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  merchantClass: PropTypes.string,


};





export default connect(mapStateToProps, mapDispatchToProps)(POSSingle);
